import { Market } from "../../contracts";
import { MarketTemplate } from "../../data";
import { CardConfiguration, MarketsBySportType, LeaguesConfiguration, MarketConfigType } from "../../typings";
import { setSportId } from "../../helpers";
import { fillEmptySelections } from "../fillEmptySelections";
import { sortIceHockeyBothTeamToScore } from "../../composables/sorters";

const BOT_TEAM_TO_SCORE_MARKET_TYPE_ID = "1227";
/**
 * Filter markets where marketType.id is available in cardConfig for specific sportId
 * @param markets
 * @param cardConfig
 */
export const filterMarkets = (marketsBySport: MarketsBySportType, cardConfig: CardConfiguration, specialLeagues: LeaguesConfiguration): MarketsBySportType => {
    let sportIds: string[] = Object.keys(cardConfig);
    let leagueIds: string[] = Object.keys(specialLeagues);
    let currentSportId: string;

    Object.keys(cardConfig).map(sportId => {
        let marketsInConfig = cardConfig[sportId].markets;
        marketsInConfig.map(m => {
            let template: MarketTemplate;

            marketsBySport[sportId].forEach((market) => {
                currentSportId = setSportId(sportIds, market);
                template = getTemplate(market, m, specialLeagues, leagueIds);
                let shouldFillEmptySelection = ignoreFilterForSpecialMarkets(market);
                sortSpecialMarkets(!shouldFillEmptySelection, market);
                currentSportId === sportId
                    && (market.marketType.id === m.idLive || market.marketType.id === m.idPreLive) && (market.template = template)
                    && shouldFillEmptySelection && (market.selections = (
                        fillEmptySelections(market.selections, template, cardConfig[sportId].cardType))
                    );
            })
        })
    });

    return marketsBySport;
}

function ignoreFilterForSpecialMarkets(market: Market) {
    return !(market.marketType.id === BOT_TEAM_TO_SCORE_MARKET_TYPE_ID && market.selections.length === 2);
}

function sortSpecialMarkets(shouldSort: boolean, market: Market) {
    shouldSort && (market.selections = market.selections.sort(sortIceHockeyBothTeamToScore));
}
/**
 * Get specialLeague template to use
 * @param {Market} market
 * @param {MarketConfigType} m
 * @param {LeaguesConfiguration} specialLeagues are leagues that apply template, different from template in config
 * @param {string[]} leagueIds
 */
const getTemplate = (market: Market, m: MarketConfigType, specialLeagues: LeaguesConfiguration, leagueIds: string[]) => {
    return leagueIds && leagueIds.indexOf(market.leagueId) !== -1
        ? specialLeagues[market.leagueId]
        : m.template;
}